import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Handshake } from "lucide-react";
import { toast } from "sonner";

// Staff-only: link or correct a person's Referral Partner attribution (recruiter assignment is separate).
export function ReferralAttributionPanel({ personId }) {
  const [d, setD] = useState(null);
  const [partners, setPartners] = useState([]);
  const [pick, setPick] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/referral-admin/person/${personId}`).then((r) => setD(r.data)).catch(() => setD(false));
  useEffect(() => {
    load();
    api.get("/referral-admin/partners").then((r) => setPartners(r.data.items || [])).catch(() => setPartners([]));
  }, [personId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (d === false || d === null) return null;
  const rel = d.relationship;
  const save = async (replace = false) => {
    setBusy(true);
    try {
      await api.post(`/referral-admin/person/${personId}`, { partner_user_id: pick || undefined, code: code || undefined, replace });
      toast.success("Referral attribution saved"); setPick(""); setCode(""); load();
    } catch (e) {
      if (e?.response?.status === 409 && window.confirm(`${apiError(e)}\n\nReplace the existing referral partner?`)) { setBusy(false); return save(true); }
      toast.error(apiError(e));
    } finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="referral-attribution-panel">
      <h3 className="text-sm font-semibold text-slate-900 flex items-center gap-1.5 mb-2"><Handshake className="w-4 h-4 text-[#006090]" />Referral Partner</h3>
      <p className="text-sm text-slate-700" data-testid="referral-attribution-current">{rel ? <>Referred by <strong>{rel.referrer_name}</strong> <span className="text-xs text-slate-400">({rel.source || "Referral"})</span></> : "No referral partner linked."}</p>
      {d.open_reviews > 0 && <p className="text-xs text-amber-700 mt-1" data-testid="referral-attribution-review">{d.open_reviews} attribution conflict awaiting review</p>}
      <div className="mt-3 space-y-2">
        <select value={pick} onChange={(e) => { setPick(e.target.value); setCode(""); }} className="w-full h-9 rounded-md border border-slate-200 px-2 text-sm" data-testid="referral-attribution-select">
          <option value="">Choose a Referral Partner…</option>
          {partners.map((p) => <option key={p.id} value={p.id}>{p.name || p.email}</option>)}
        </select>
        <input value={code} onChange={(e) => { setCode(e.target.value.trim()); setPick(""); }} placeholder="…or enter a referral code" className="w-full h-9 rounded-md border border-slate-200 px-2 text-sm" data-testid="referral-attribution-code" />
        <Button size="sm" variant="outline" disabled={busy || !(pick || code)} onClick={() => save(false)} data-testid="referral-attribution-save">{rel ? "Correct Attribution" : "Link Referral Partner"}</Button>
      </div>
    </div>
  );
}
